import type { OnInit } from '@angular/core';
import { Component, Input } from '@angular/core';
import { type OrderCrossSellFormValues } from '@innogy/become-a-customer/state';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { getFieldValue } from '@core/jss-utils';
import type { StoreProductData } from '@legacy/common-ui-models';
import { Store } from '@ngrx/store';
import { SetValueAction } from 'ngrx-forms';

import { OrderFulfillmentStepComponent } from '../order-fulfillment-step.component';
import { CrossSellProductInfoModalComponent } from '../../../modals/cross-sell-product-info-modal.component';

@Component({
  selector: 'wl-order-fulfillment-cross-sell[progressiveFormState]',
  templateUrl: './order-fulfillment-cross-sell.component.html',
  styleUrls: ['./order-fulfillment-cross-sell.component.essent.scss'],
})
export class OrderFulfillmentCrossSellComponent
  extends OrderFulfillmentStepComponent<OrderCrossSellFormValues>
  implements OnInit
{
  // eslint-disable-next-line @angular-eslint/prefer-signals
  @Input({ required: true }) product!: StoreProductData;

  constructor(
    private readonly modalService: NgbModal,
    private readonly store$: Store
  ) {
    super();
  }

  ngOnInit(): void {
    this.progressiveFormCardContent = {
      title: getFieldValue(this.fields, 'CrossSellCardTitle', ''),
      subtitle: getFieldValue(this.fields, 'CrossSellCardSubtitle', ''),
      submitButtonText: getFieldValue(
        this.fields,
        'CrossSellCardSubmitButton',
        ''
      ),
      stepNumber: this.stepNumber,
    };
  }

  onCardClick($event: Event) {
    $event.preventDefault();

    if (this.formState) {
      this.store$.dispatch(
        new SetValueAction(
          this.formState.controls.hasSelectedProduct.id,
          !this.formState.controls.hasSelectedProduct.value
        )
      );
    }
  }

  onMoreInfoClick($event: Event) {
    $event.stopPropagation();

    this.modalService.dismissAll();
    const modal = this.modalService.open(CrossSellProductInfoModalComponent, {
      modalDialogClass: 'modal-shadow',
      animation: true,
      centered: true,
    });
    modal.componentInstance.rendering = this.rendering;
    modal.componentInstance.product = this.product;
    modal.componentInstance.formState = this.formState;
  }

  get usps() {
    return (
      this.product.content.usps
        ?.slice(0, 3)
        .map((usp) => ({ ...usp, tooltip: '' })) ?? []
    );
  }
}
